<mat-expansion-panel
  (closed)="panelOpenState = false"
  (opened)="panelOpenState = true"
  [expanded]="panelOpenState"
  class="{{ customClass }}"
  hideToggle>
  <mat-expansion-panel-header>
    <mat-panel-title class="expansion-panel-title heading-xs">
      @if (icon) {
        <mat-icon class="expansion-panel-icon expansion-panel-icon-title">{{ icon }}
        </mat-icon>
      }
      @if (svgIcon) {
        <mat-icon
          class="expansion-panel-icon-svg"
          svgIcon="{{ svgIcon }}"></mat-icon>
      }
      {{ title }}
    </mat-panel-title>
    <mat-icon class="expansion-panel-icon">
      {{ !panelOpenState ? 'arrow_drop_down' : 'arrow_drop_up' }}
    </mat-icon>
  </mat-expansion-panel-header>
  @if (content) {
    <p class="body-l expansion-panel-content">{{ content }}</p>
  }
  <ng-content></ng-content>
</mat-expansion-panel>
